import React from 'react';

const OffersSection = () => {
  const sections = {
    'Your Dedicated Team': {
      title: 'A team that knows your business.',
      description:
        'Work with a consistent team of finance professionals who understand your goals and operations.',
    },
    'Your Accounting Options': {
      title: 'Flexible solutions that fit your needs.',
      description:
        'Choose from cash or accrual accounting, with services tailored to your business size and complexity.',
    },
    'Your Custom Quote Process': {
      title: 'Pricing built around you.',
      description:
        'Get a personalized quote based on your specific business requirements and financial goals.',
    },
    'Your Full-Charge Bookkeeper': {
      title: 'End-to-end financial management.',
      description:
        'A dedicated bookkeeper handles everything from daily transactions to month-end reporting.',
    },
  };
  return (
    <section className="py-5 mb-5">
      <div className="container">
        <div className="row">
          <div className="col-md-6 mb-5 mb-md-0">
            <img
              src="assets/images/20.png"
              alt="special offers"
              className="img-fluid"
              width="492px"
              style={{ marginTop: '-70px' }}
            />
          </div>
          <div className="col-md-6">
            <h2 className="section-title">What To Expect</h2>
            <p className="mb-5">
              {/* He has led a remarkable campaign, defying the traditional mainstream parties courtesy of his En Marche! movement... */}
            </p>
            <div className="row">
              {Object.entries(sections).map(([heading, { title, description }]) => (
                <div className="col-md-6 mb-3" key={heading}>
                  <div className="media landing-feature">
                    <span className="landing-feature-icon"></span>
                    <div className="media-body">
                      <h6>{heading}</h6>
                      <strong>
                        <small>{title}</small>
                      </strong>
                      <p>{description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OffersSection;
